module.exports = __webpack_public_path__ + "img/servicios-escritorio.3a339f87.png";